'use client';

import React from 'react';
import SlideWrapper from '../SlideWrapper';
import { Utensils, Film, Award, Moon, Flame } from 'lucide-react';

interface Props {
  id: string;
  registerRef: (id: string, el: HTMLElement | null) => void;
}

const activities = [
{
  icon: <Utensils size={18} className="text-[#e8a030]" />,
  time: '07:00 – 09:00',
  title: 'Ăn sáng',
  desc: 'Bữa sáng khởi đầu ngày cuối hành trình.',
  accent: '#e8a030'
},
{
  icon: <Film size={18} className="text-[#4caf7d]" />,
  time: '09:00 – 12:15',
  title: 'Hoàn thiện clip – hình ảnh – lời nhắn',
  desc: 'Các đội hoàn thiện video kỷ niệm.',
  accent: '#4caf7d'
},
{
  icon: <Utensils size={18} className="text-[#e8a030]" />,
  time: '12:15 – 13:30',
  title: 'Ăn trưa',
  desc: 'Bữa trưa trước buổi lễ tổng kết.',
  accent: '#e8a030'
},
{
  icon: <Award size={18} className="text-[#f5c96a]" />,
  time: '13:30 – 16:30',
  title: 'Tổng kết – trao giải – ambassador',
  desc: 'Trao chứng nhận, vinh danh và ghi nhận đóng góp.',
  accent: '#f5c96a'
},
{
  icon: <Utensils size={18} className="text-[#e8a030]" />,
  time: '16:30 – 19:00',
  title: 'Ăn tối – sinh hoạt cá nhân',
  desc: 'Bữa tối và thời gian tự do cá nhân.',
  accent: '#e8a030'
},
{
  icon: <Moon size={18} className="text-[#a8d87a]" />,
  time: '19:00 – 21:30',
  title: 'Hoạt động đêm cuối – Palmistry & chia sẻ',
  desc: 'Tạo không gian cảm xúc nhẹ, kết nối cá nhân.',
  accent: '#a8d87a'
},
{
  icon: <Flame size={18} className="text-[#f5c96a]" />,
  time: '21:30',
  title: 'Lửa trại kết thúc hành trình',
  desc: 'Vòng tròn chia sẻ, recap hành trình, ảnh tập thể, video chia tay.',
  accent: '#f5c96a'
}];


export default function Slide12fDay7({ id, registerRef }: Props) {
  return (
    <SlideWrapper id={id} registerRef={registerRef} className="bg-[#0a1a0f]">
      <div className="absolute inset-0">
        <img
          src="https://images.unsplash.com/photo-1485880737735-b5b29c71ca4f"
          alt="Lửa trại bập bùng trong đêm tối, ánh lửa ấm áp chiếu sáng khuôn mặt những người ngồi quanh"
          className="w-full h-full object-cover opacity-10" />
        
        <div className="absolute inset-0 bg-gradient-to-br from-[#1a2a0a]/70 via-[#0a1a0f] to-[#0a1a0f]" />
        <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[rgba(245,201,106,0.4)] to-transparent" />
      </div>

      <div className="relative z-10 max-w-screen-xl mx-auto px-6 lg:px-16 xl:px-24 py-24 pt-28 min-h-screen flex flex-col justify-center">
        <div className="fade-in-up mb-4">
          <div className="chapter-badge amber">
            <span className="w-1.5 h-1.5 rounded-full bg-[#f5c96a] inline-block" />
            Hành trình 8 ngày 7 đêm
          </div>
        </div>

        <div className="fade-in-up mb-3">
          <h2 className="font-display font-800 text-[clamp(24px,3.5vw,48px)] leading-[1.1] text-[#f0ede6] tracking-tight">
            NGÀY 7
          </h2>
          <h2 className="font-display font-800 text-[clamp(18px,2.5vw,32px)] leading-[1.3] tracking-tight text-gradient-amber">
            Tổng kết – Trao giải – Lửa trại kết thúc
          </h2>
        </div>

        <div className="fade-in-up mb-8">
          <div className="w-[60px] h-[3px] bg-gradient-to-r from-[#e8a030] to-[#f5c96a] rounded-full" />
        </div>

        <div className="relative fade-in-up">
          <div className="absolute left-[22px] top-0 bottom-0 w-px bg-gradient-to-b from-[#f5c96a]/60 via-[#4caf7d]/40 to-transparent" />
          <div className="flex flex-col gap-4">
            {activities.map((act, i) =>
            <div key={`d7-${i}`} className="flex items-start gap-4 pl-2">
                <div
                className="flex-shrink-0 w-9 h-9 rounded-full flex items-center justify-center z-10"
                style={{ background: `${act.accent}22`, border: `1.5px solid ${act.accent}55` }}>
                
                  {act.icon}
                </div>
                <div
                className="flex-1 rounded-xl p-4 transition-all duration-300 hover:-translate-y-0.5"
                style={{ background: `${act.accent}0d`, border: `1px solid ${act.accent}22` }}>
                
                  <div className="flex flex-wrap items-center gap-2 mb-1">
                    <span
                    className="font-body font-700 text-[11px] tabular-nums px-2 py-0.5 rounded-full"
                    style={{ color: act.accent, background: `${act.accent}18` }}>
                    
                      {act.time}
                    </span>
                    <h3 className="font-display font-700 text-[14px] lg:text-[15px] text-[#f0ede6]">
                      {act.title}
                    </h3>
                  </div>
                  <p className="font-body text-[12px] lg:text-[13px] text-[#a0b8a8] leading-relaxed">
                    {act.desc}
                  </p>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </SlideWrapper>);

}